module.exports = __webpack_public_path__ + "static/media/meet-piper-tablet-es.0a2f9fb3.svg";